import AmountRequested from './amount-requested';

export default AmountRequested;